<template>
  <div class="promo-code-card">
    <div class="row">
      <div class="col-6 text-left code">
        <strong>{{ $t('generic.code', 'Code') }}:</strong> <span>{{ code }}</span>
      </div>
      <div class="col-6 text-right uses">
        {{
          $t(
            'pages.my-account.promos.card.uses',
            '{remaining} uses out of {limit}',
            {remaining: limit - used, limit}
          )
        }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right type">
        <div
          v-if="type === 'offer'"
        >
          {{
            $t(
              'pages.my-account.promos.card.discount',
              '{discount} € discount for offer!',
              {discount}
            )
          }}
        </div>
        <div
          v-else-if="type === 'multiprovincia'"
        >
          {{
            $t(
              'pages.my-account.promos.card.multiprovince',
              'Multiprovince promo for {count} provinces!',
              { count: discount }
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromoCode",
  props: {
    code: {
      type: String,
      default: 'XXXXXXXXXXXXXXXXXXXXX',
    },
    limit: {
      type: Number,
      default: 0,
    },
    used: {
      type: Number,
      default: 0,
    },
    discount: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'offer',
    }
  }
}
</script>

<style lang="scss" scoped>
.promo-code-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin: 12px;
  width: 50%;
  transition: 0.3s ease;

  &:hover {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.04), 0 1px 16px 0 rgba(0, 0, 0, 0.16), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
    background-color: #f6fafc;
  }

  .code {
    span {
      padding: 3px;
      margin-left: 4px;
      background: rgba(#000, 0.1);
    }
  }

  .type {
    font-size: 0.8em;
  }
}
</style>